import { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

export interface DetailsCellProps {
  children: ReactNode
  className?: string
  isLastCell?: boolean
  isOnlyCell?: boolean
}

export function DetailsCell({ children, className, isLastCell, isOnlyCell }: DetailsCellProps) {
  return (
    <div
      className={twMerge(
        `col-span-4 px-6 pt-6 pb-0 md:col-span-2  md:pb-6`,
        isLastCell ? 'pb-6' : '',
        isLastCell && !isOnlyCell ? 'md:border-shades-200 md:border-l md:border-dashed' : '',
        className ?? ''
      )}
    >
      {children}
    </div>
  )
}
